import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../text/messages';

export default class Question {
    static typeDefinitions = {
        boolean: {
            type: 'y/n',
            hasOptions: true,
            defaultOptions: [{ label: <FormattedMessage {...messages.yes} />, value: true }, { label: <FormattedMessage {...messages.no} />, value: false }]
        },
        multi: { type: 'multi', hasOptions: true, optionsProp: 'choices' },
        choice: { type: 'select', hasOptions: true, optionsProp: 'choices' },
        date: { type: 'date', hasOptions: false }
    };

    type;
    label;
    helpText;
    id;
    name;
    options;
    followups;
    placeholder;
    isFollowup;
    answer;
    scoring;

    constructor(data) {
        let { answer_type, attributes, id, help_text, is_followup, title, answer, scoring } = data;
        this.type = answer_type;
        this.label = title;
        this.helpText = help_text;
        this.options = this.getOptions(data);
        this.followups = attributes ? attributes.followups : undefined;
        this.placeholder = attributes ? attributes.placeHolder : undefined;
        this.answer = answer;
        this.scoring = scoring;

        this.id = id;
        this.isFollowup = is_followup;
        this.name = this.isFollowup ? id.replace(':', '.') : `${id}.value`;
    }

    getTypeDefinition(type) {
        let typeDefinitions = Object.keys(Question.typeDefinitions).filter(k => Question.typeDefinitions[k] && Question.typeDefinitions[k].type === type);
        if (!typeDefinitions || typeDefinitions.length !== 1) {
            return undefined;
        }

        return Question.typeDefinitions[typeDefinitions[0]];
    }

    getOptions(data) {
        let { answer_type, attributes } = data;

        let typeDefinition = this.getTypeDefinition(answer_type);
        if (!typeDefinition || !typeDefinition.hasOptions) {
            return undefined;
        }

        if (typeDefinition.optionsProp && attributes[typeDefinition.optionsProp]) {
            return attributes[typeDefinition.optionsProp].map(o => ({ label: o, value: o }));
        }

        return typeDefinition.defaultOptions;
    }

    hasFollowups() {
        return this.followups && this.followups.length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/models/question.jsx